import { ThemeUICSSObject, spacing } from '@apia/theme';

const imageSelector: ThemeUICSSObject = {
  flexDirection: 'column',
  gap: spacing(4),

  'button.imageButton': {
    p: spacing(2),
  },

  img: {
    width: '60px',
    height: '60px',
  },

  Modal: {
    '.spinner': {
      textAlign: 'center',
    },
    '.error': {
      color: 'darkred',
      mb: spacing(0),
    },

    '[role="grid"]': {
      mx: 'auto',
      '[role="row"]': {
        display: 'grid',
        gap: spacing(5),
        mb: spacing(5),
        '& div:focus': {
          outline: '3px solid',
          outlineColor: 'outlineColor',
        },

        '[role="cell"]': {
          border: '1px solid #ccc',
          padding: 4,
        },
      },
      div: {
        display: 'inline-block',
        background: 'none',
        border: 'none',

        img: {
          display: 'block',
          width: '60px',
          height: '60px',
        },
      },
    },
  },
};

export default imageSelector;
